// @ts-nocheck

export const validateBeforeRouteLeave = {
  methods: {
    validateForm () {
      return true
    }
  },
  beforeRouteLeave (to, from, next) {
    const isValid = this.validateForm()
    if (isValid) return next()
    else return false
  }
}